import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminServices from '../../services/AdminServices';
import Cookies from 'js-cookie';

function Login({ setIsAuthenticated, setRole }) {
  const [mobileOrEmail, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const rememberedEmail = Cookies.get('rememberEmail');
    const rememberedPassword = Cookies.get('rememberPassword');

    if (rememberedEmail) setEmail(rememberedEmail);
    if (rememberedPassword) setPassword(rememberedPassword);
  }, []);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // console.log(mobileOrEmail, password);
  //     const data = await AdminServices.login({ mobileOrEmail, password });
    
  //     if (data.status === true) {
  //       localStorage.setItem('authToken', data?.token);
  //       localStorage.setItem('userRole', data?.data?.role);
  //       localStorage.setItem('name', data?.data?.name);
  //       localStorage.setItem('image', data?.data?.image);
  //       const permissionsData = await AdminServices.getPermissions(data?.data?.role);
  //       const permissions = {};
  //       permissionsData.data.forEach(item => {
  //         permissions[item.menuItem] = item.roles[data?.data?.role];
  //       });
  //       localStorage.setItem('userPermissions', JSON.stringify(permissions));
    
  //       setIsAuthenticated(true);
  //         // navigate('/dashboard');
  //         window.location.reload();
  //      }else{
  //       setError("*Invalid Credentials");
  //      }
  //     };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await AdminServices.login({ mobileOrEmail, password });
  
      if (data.status === true) {
        
        localStorage.setItem('authToken', data?.token);
        localStorage.setItem('userRole', data?.data?.role);
        localStorage.setItem('name', data?.data?.name);
        localStorage.setItem('image', data?.data?.image);
  
       
        const permissionsData = await AdminServices.getPermissions(data?.data?.role);
        const permissions = {};
        permissionsData.data.forEach((item) => {
          permissions[item.menuItem] = item.roles[data?.data?.role];
        });
        localStorage.setItem('userPermissions', JSON.stringify(permissions));

        
      const rememberPassword = document.getElementById('flexCheckChecked').checked;
      if (rememberPassword) {
        Cookies.set('rememberEmail', mobileOrEmail, { expires: 7 });
        Cookies.set('rememberPassword', password, { expires: 7 }); // Avoid storing plaintext passwords
      } else {
        Cookies.remove('rememberEmail');
        Cookies.remove('rememberPassword');
      }

  
        setIsAuthenticated(true);
        window.location.reload();
      } else {
        setError('*Invalid Credentials');
      }
    } catch (err) {
      // Check if the error response exists
      if (err.response && err.response.data && err.response.data.message) {
        setError(`*${err.response.data.message}`);
      } else {
        setError('*Something went wrong. Please try again.');
      }
    }
  };
  
  return (
    <div className="login-section">
      <div className="login-section-inner">
        <div className="row">
          <div className="col-md-6 pe-0">
            <div className="login-section-left">
              <h1>Login</h1>
              <p>Welcome to the Admin Panel!</p>
              <form className="user-login" >
                <div className="input-field mb-3">
                  <label htmlFor="userEmail" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="userEmail"
                    placeholder="example@example.com"
                    value={mobileOrEmail}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                </div>
                <div className="input-field mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="••••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="form-check d-flex align-items-center gap-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue=""
                    id="flexCheckChecked"
                    defaultChecked=""
                  />
                  <label className="form-check-label" htmlFor="flexCheckChecked">
                    Remember me
                  </label>
                </div>
                   {/* Error Message Section */}
                   {error && (
                  <div style={{ color: 'red', marginBottom: '10px', fontSize: '14px' }}>
                    {error}
                  </div>
                )}
                <div className="input-field mb-3">
                  <input
                    onClick={handleSubmit}
                    type="submit"
                    className="form-control"
                    id="login-btn"
                    value="Login"
                  />
                </div>
              </form>
              {/* <p>© 2024 Pashuchikitsa Made by <a href="https://truevalueinfosoft.com/">True Value Infosoft</a>.</p> */}
            </div>
          </div>
          <div className="col-md-6 ps-0">
            <div className="login-section-right">
              <div className="logo-field">
                <img src="img/logo.svg" alt="Logo" />
              </div>
              <div className="light-field px-4">
                <img src="img/cuate.svg" alt="Illustration" />
              </div>
            </div>
          </div>
        </div>
        <p className="company-details">
          © 2025–2026 Savasati. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Login;
